<div id="{{theme}}-app" class="app container-fluid">
    <!-- Header -->

    <!-- Removed internal condition TCCP-1734 -->
    <div class="row">
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12">
            <app-home-header></app-home-header>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12" *ngIf="!hideBanner">
            <app-banner></app-banner>
        </div>

        <!-- New model-year & vin Selection Starts -->
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12" *ngIf="windowWidth<=1024">
            <app-mode-year-vin-selection></app-mode-year-vin-selection>
        </div>
        <!-- New model-year & vin Selection Ends -->

    </div>

    <!-- Content -->
    <div class="row" [appOutSideClick]="'lexus'">
        <div class="col-md-12 col-xl-12 col-sm-12 content">
            <main class="body-wrapper" id="body-wrapper" [hidden]="hideBreadcrumb">
                <div class="lexus-background-image"></div>
                <div class="content">
                    <div id="overlay"></div>
                    <div class="row h-60 text-center">
                        <div class="row p-0 breadcrumb-block col-12" *ngIf="!hideBreadcrumb">
                            <app-breadcrumb></app-breadcrumb>
                        </div>
                        <div class="content-block col-sm-12">
                            <app-loader></app-loader>
                            <router-outlet> </router-outlet>
                        </div>
                    </div>
                </div>
            </main>
            <main class="text-center" [hidden]="!hideBreadcrumb">
                <app-loader></app-loader>
                <app-home-carousel></app-home-carousel>
            </main>
        </div>
    </div>

    <!-- Footer -->
    <div class="row" [appOutSideClick]="'lexus'">
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12">
            <app-footer-resources></app-footer-resources>
        </div>
    </div>

    <!-- Footer -->
    <div class="row" [appOutSideClick]="'lexus'">
        <div class="col-md-12 col-xl-12 col-sm-12 col-lg-12">
            <app-footer></app-footer>
        </div>
    </div>


</div>